import "./PresentationSection.css";

const PresentationSection = () => {
  return (
    <section className="presentacion-1">
      <div className="container">
        <div className="row">
          {/* Texto */}
          <div className="col-md-6 info">
            <h3>
              TU BODA ES ÚNICA,
              <br />
              TU INVITACIÓN TAMBIÉN
            </h3>
            <ul style={{paddingTop: '15px', paddingLeft: '20px'}}>
              <li style={{paddingBottom: '10px'}}>
                En solo 24 hs. creamos una web personalizada con todos los
                detalles de tu evento
              </li>
              <li style={{paddingBottom: '10px'}}>
                Compartila de forma simple y sustentable a través de whatsapp,
                instagram, email o como prefieras.
              </li>
              <li style={{paddingBottom: '10px'}}>
                Solo compartes un link y tus invitados acceden a toda la
                información!
              </li>
            </ul>
            <br />

            <a href="#invitaciones" className="boton verde">
              Quiero conocer más
            </a>
          </div>

          {/* Imagen */}
          <div className="col-md-6">
            <img
              src="https://noscasamos.ar/wp-content/uploads/2022/07/Tarjetas.png"
              alt="Invitaciones Digitales Agenda la fecha"
              title="Invitaciones Digitales Agenda la fecha"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PresentationSection;
